import { observable } from "mobx";
import { Type } from "class-transformer";
import type { IEnum } from "./enum";
import CountryLocalizationResponse from "./countryLocalizationResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CountryResponse implements IEnum {
  /**
   * Country ID.
   * @example
   * 389f9475-192f-476f-9d6e-62934311801b
   */
  id!: string;

  /**
   * Country code in ISO 3166-1 Alpha-2 standard.
   * @example
   * CZ
   */
  @observable
  code!: string;

  /**
   * Country name.
   * @example
   * Česko
   */
  @observable
  name!: string;

  /**
   * Country created at.
   * @example
   * 07/21/2021 10:30:45 +00:00
   */
  @observable
  @Type(() => Date)
  createdAt!: Date;

  /**
   * Country updated at.
   * @example
   * 07/21/2021 10:30:45 +00:00
   */
  @observable
  @Type(() => Date)
  updatedAt!: Date;

  /**
   * Is country deleted.
   */
  @observable
  isDeleted!: boolean;

  /**
   * Is member of Single Euro Payment Area (SEPA).
   */
  @observable
  isSepaMember!: boolean;

  /**
   * Localized country names.
   */
  @observable
  @Type(() => CountryLocalizationResponse)
  localizations!: CountryLocalizationResponse[];
}
